import { useFetchTournamentsQuery } from "../store/tournament/TournamentApi";
import { useGetProfileQuery } from "../store/auth/AuthApi";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import LinearProgress from '@mui/material/LinearProgress';

import * as React from 'react';
import Alert from '@mui/material/Alert';

/*
 * Ermittelt die Benutzerdaten und die vorhandenen und
 * erlaubten Turniere, die es derzeit hier gibt. 
 */

export default function Prefetch()
{
  //const {data: user, error: userError, isLoading: userIsLoading} = useGetProfileQuery();  
  //const {data: tournaments, error: tournamentError, isLoading: tournamentIsLoading} = useFetchTournamentsQuery();
  const {isLoading: userIsLoading} = useGetProfileQuery();
  const {isLoading: tournamentIsLoading} = useFetchTournamentsQuery();
  const currentYear = useSelector(state => state.year.currentYear); 

  if (userIsLoading || tournamentIsLoading)
  {
    return (
      <React.Fragment>      
        <LinearProgress color="success" />
      </React.Fragment>
    );
  }
  else
  {
    // Prüfen, ob wir ein aktuelles Jahr haben: 
    if ((currentYear)&&(currentYear > 0))
    {
      return <Navigate to={`/${currentYear}`} />
    }
    else 
    {
      return (
        <React.Fragment>              
          <Alert severity="error">Benutzer entweder nicht gefunden oder besitzt keine Berechtigung.</Alert>
        </React.Fragment>      
      );
    }
  }
}